import { ConnectionPositionPair } from '@angular/cdk/overlay';

export const DEFAULT_AVATAR_SIZE = 40;
export const DEFAULT_BADGE_BREAKPOINT = 38;
export const DEFAULT_STACKED_AVATARS_DISPLAY_LIMIT = 3;
export const DEFAULT_POSITION_PAIR = [
  /* RIGHT */ new ConnectionPositionPair(
    { originX: 'end', originY: 'top' },
    { overlayX: 'start', overlayY: 'top' },
    10,
    0,
  ),
  /* LEFT */ new ConnectionPositionPair(
    { originX: 'start', originY: 'top' },
    { overlayX: 'end', overlayY: 'top' },
    -10,
    0,
  ),
  /* BOTTOM */ new ConnectionPositionPair(
    { originX: 'start', originY: 'bottom' },
    { overlayX: 'start', overlayY: 'top' },
    0,
    10,
  ),
  /* TOP */ new ConnectionPositionPair(
    { originX: 'start', originY: 'top' },
    { overlayX: 'start', overlayY: 'bottom' },
    0,
    -10,
  ),
];
